import { useSelector } from "react-redux";

import Loader from "../components/other/Loader";

const Support = () => {
  const { isToggle, isLoading } = useSelector((state) => state.authReducer);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <section className="ct_login_bg_main">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-5 col-xl-6 col-lg-6 col-md-12 ms-auto">
              <section class="cs_child_safety ct_ride_side_sidebar">
                <div class="cs_container">
                  <h2 class="cs_title">Child Safety Standards</h2>
                  <p class="cs_subtitle">
                    We are committed to maintaining a safe, respectful, and
                    secure environment for everyone.
                  </p>

                  <div class="cs_card">
                    <ul class="cs_list">
                      <li>
                        <span class="cs_icon">🛑</span>
                        <p>
                          We strictly prohibit child sexual abuse and
                          exploitation (CSAE/CSAM) on our platform.
                        </p>
                      </li>

                      <li>
                        <span class="cs_icon">🚫</span>
                        <p>
                          Users are not allowed to upload, share, or distribute
                          any content involving minors in a sexual or
                          exploitative manner.
                        </p>
                      </li>

                      <li>
                        <span class="cs_icon">📢</span>
                        <p>
                          We provide in-app reporting tools for users to report
                          inappropriate content or behavior.
                        </p>
                      </li>

                      <li>
                        <span class="cs_icon">⚖️</span>
                        <p>
                          All reported content is reviewed and appropriate
                          action is taken, including account suspension and
                          reporting to relevant authorities when required by
                          law.
                        </p>
                      </li>
                    </ul>

                    <div class="cs_contact">
                      <strong>Child Safety Concerns?</strong>
                      <a
                        href="mailto:support@xder.app"
                        className="ct_orange_text"
                      >
                        support@xder.app
                      </a>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Support;
